import MatomoMessage from '@/matomo/message/MatomoMessage';
import MatomoContext from '@/matomo/domain/MatomoContext';
import MatomoQuantityMessage from '@/matomo/message/MatomoQuantityMessage';

export default class MatomoContextualQuantityMessage {
  private readonly message: MatomoMessage;

  private constructor(message: MatomoMessage) {
    this.message = message;
  }

  public static from(message: MatomoMessage): MatomoContextualQuantityMessage {
    return new MatomoContextualQuantityMessage(message);
  }

  public with(context: MatomoContext): MatomoQuantityMessage {
    return MatomoQuantityMessage.from(this.message.with(context.source));
  }
}
